var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_5743)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6299 4.45129C12.2629 4.74821 11.7383 4.74821 11.3713 4.45129C10.5693 3.81122 9.49579 3.62531 8.52519 3.95837C7.55458 4.29143 6.82142 5.0973 6.58135 6.09498C6.49645 6.48315 6.19253 6.7859 5.80403 6.8693C4.66191 7.10111 3.70998 7.88596 3.2647 8.96294C2.81942 10.0399 2.93916 11.2679 3.5841 12.2385C3.8165 12.5788 3.8165 13.0267 3.5841 13.367C2.93916 14.3377 2.81942 15.5656 3.2647 16.6426C3.70998 17.7196 4.66191 18.5044 5.80403 18.7362C6.19253 18.8196 6.49645 19.1224 6.58135 19.5106C6.82273 20.5074 7.55642 21.3119 8.52683 21.6439C9.49723 21.9759 10.57 21.7893 11.3713 21.1492C11.7383 20.8523 12.2629 20.8523 12.6299 21.1492C13.4326 21.7893 14.5069 21.9746 15.4777 21.6405C16.4485 21.3063 17.1811 20.4991 17.4199 19.5006C17.5048 19.1124 17.8087 18.8096 18.1972 18.7262C19.3395 18.4943 20.2914 17.7092 20.7365 16.6319C21.1816 15.5547 21.0615 14.3266 20.4161 13.356C20.1846 13.0162 20.1846 12.5693 20.4161 12.2295C21.0615 11.2589 21.1816 10.0308 20.7365 8.95361C20.2914 7.87637 19.3395 7.09124 18.1972 6.85929C17.8087 6.7759 17.5048 6.47315 17.4199 6.08497C17.1785 5.08816 16.4448 4.28363 15.4744 3.95165C14.504 3.61967 13.4312 3.80621 12.6299 4.44629V4.45129Z",
    stroke: "#57569C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 4.67285V20.9226",
    stroke: "#57569C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.001 16.7997C15.001 15.6946 15.8968 14.7988 17.0018 14.7988",
    stroke: "#57569C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99888 8.7959C8.99888 9.90093 8.10308 10.7967 6.99805 10.7967",
    stroke: "#57569C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99888 16.7997C8.99888 15.6946 8.10308 14.7988 6.99805 14.7988",
    stroke: "#57569C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.001 8.7959C15.001 9.90093 15.8968 10.7967 17.0018 10.7967",
    stroke: "#57569C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_5743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.797852)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrain);
export default __webpack_public_path__ + "static/media/Brain.0fca9e1354368535aa2717296237de58.svg";
export { ForwardRef as ReactComponent };